import { useEffect, useState } from "react";
import { useLocation, matchPath } from "react-router-dom";
import { brandRoutesWithGradientBg } from "../constants";
import useAuth from "./useAuth";

export const usePageGradientBg = () => {
  const [isGradientBg, setIsGradientBg] = useState(false);
  const { id: userId } = useAuth();
  const location = useLocation();

  useEffect(() => {
    !userId
      ? setIsGradientBg(true)
      : brandRoutesWithGradientBg.forEach((route) => {
          const match = matchPath(location.pathname, {
            path: route,
            exact: true,
          });
          if (match) {
            setIsGradientBg(true);
          }
        });

    return () => setIsGradientBg(false);
  }, [location.pathname, userId]);

  return { isGradientBg };
};
